import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { UIHelper } from '../../utils/UIHelper';
import { AppConfigurationStore, DownloadOption } from '../../stores/AppConfigurationStore';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { LongButton } from '../LongButton';
import { ToggleGroup } from '../ToggleGroup';
import { DownloadButton } from '../DownloadButton';
import { ArticleListMaker } from '../../utils/ArticleListMaker';
import { ShareBaseTab } from './ShareBaseTab';

interface ShareDLState {
}

export class ShareDL extends ShareBaseTab<ShareDLState> {
    public componentDidMount(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }

    public componentDidUpdate(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }

    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }
        return (
            <div className="sidebar-tab-container" key={this.props.layoutType.toString()}><div className="scrollbar-wcf">
                {this.header(t('Download'))}
                <div className="sidebar-content standard-header">
                    <div className={'long-button-group' + (AppConfigurationStore.getState().inApp ? '' : ' with-title active')}>
                        <LongButton shortBorder={true} icon="dl-button" onClick={DownloadHelper.downloadScreenshot}>{t('Image')}</LongButton>
                    </div>
                    {AppConfigurationStore.getState().inApp ?
                        <div className="sidebar-subheader">{t('Commercial Information')}</div> :
                        null
                    }
                    <ToggleGroup title={t('Commercial Information')}>
                        {AppConfigurationStore.getState().articleListTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <DownloadButton key={index + '-al'} option={downloadOption} callback={ArticleListMaker.download}/>;
                        })}
                        {AppConfigurationStore.getState().commercialDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <DownloadButton key={index + '-com'} option={downloadOption} callback={DownloadHelper.downloadExport}/>;
                        })}
                    </ToggleGroup>
                    {AppConfigurationStore.getState().inApp ?
                        <div className="sidebar-subheader">{t('CAD Symbols')}</div> :
                        null
                    }
                    <ToggleGroup title={t('CAD Symbols')}>
                        {AppConfigurationStore.getState().cadDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <DownloadButton key={index + '-cad'} option={downloadOption} callback={DownloadHelper.downloadExport}/>;
                        })}
                    </ToggleGroup>
                </div>
            </div></div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/ShareDL.tsx